module.exports = __webpack_public_path__ + "img/jingmi1kg.da97110d.jpg";